//@flow
import type { errorMapForOrderStateType } from '../PollingOrder/lib';
import I18n from '../../lib/i18n';

export type WalletActionType = {|
  type: 'ADD_MONEY',
  payload: {|
    amount: string,
    type: 'WALLET' | 'PREMIUM',
    errorMapForOrderState: errorMapForOrderStateType,
  |},
|};

export const addMoney = (amount: string, type: 'WALLET' | 'PREMIUM'): WalletActionType => ({
  type: 'ADD_MONEY',
  payload: {
    amount,
    type,
    errorMapForOrderState: {
      key: 'addMoney',
      type: {
        FAILED: {
          title: I18n.t('Dashboard.AddMoneyWithCreditCard.wallet.failureTitle'),
        },
        IN_PROGRESS: {
          title: I18n.t('Dashboard.AddMoneyWithCreditCard.wallet.inProgressTitle'),
        },
      },
    },
  },
});
